/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
// thunks
import { fetchRevenueDetailData } from '../thunks/revenue';



/* ========== ~~~~~~~~~~ REVENUE SLICE : REDUCER ~~~~~~~~~~ ========== */
const initialState = {
    lastUpdated: null,
    overview: {
        TOTAL: {
            revenue: 0,
            unitLoad: 0,
            rpm: 0,
            revenueChangeRate: 0,
            unitLoadChangeRate: 0,
            rpmChangeRate: 0
        },
        DISPLAY: {
            revenue: 0,
            unitLoad: 0,
            rpm: 0,
            revenueChangeRate: 0,
            unitLoadChangeRate: 0,
            rpmChangeRate: 0
        },
        VIDEO: {
            revenue: 0,
            unitLoad: 0,
            rpm: 0,
            revenueChangeRate: 0,
            unitLoadChangeRate: 0,
            rpmChangeRate: 0
        }
    },
    details: {
        TOTAL: {
            Daily: {
                TOTAL: {}
            },
            Monthly: {
                TOTAL: {}
            },
            Weekly: {
                TOTAL: {}
            },
            Quarterly: {
                TOTAL: {}
            }
        },
        DISPLAY: {
            Daily: {
                TOTAL: {}
            },
            Monthly: {
                TOTAL: {}
            },
            Weekly: {
                TOTAL: {}
            },
            Quarterly: {
                TOTAL: {}
            }
        },
        VIDEO: {
            Daily: {
                TOTAL: {}
            },
            Monthly: {
                TOTAL: {}
            },
            Weekly: {
                TOTAL: {}
            },
            Quarterly: {
                TOTAL: {}
            }
        }
    },
    compareTo: {
        TOTAL: {
            Daily: {
                TOTAL: {}
            },
            Monthly: {
                TOTAL: {}
            },
            Weekly: {
                TOTAL: {}
            },
            Quarterly: {
                TOTAL: {}
            }
            },
            DISPLAY: {
            Daily: {
                TOTAL: {}
            },
            Monthly: {
                TOTAL: {}
            },
            Weekly: {
                TOTAL: {}
            },
            Quarterly: {
                TOTAL: {}
            }
        },
        VIDEO: {
            Daily: {
                TOTAL: {}
            },
            Monthly: {
                TOTAL: {}
            },
            Weekly: {
                TOTAL: {}
            },
            Quarterly: {
                TOTAL: {}
            }
        }
    },
    status: 'initial',
    isRevenueDataReceived: false
}


export const revenueSlice = createSlice({
    name: 'revenue',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
        builder
            .addCase(fetchRevenueDetailData.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(fetchRevenueDetailData.fulfilled, (state, action) => {
                const { LastUpdated, Overview, Details, CompareTo } = action.payload
                if (LastUpdated) {
                    state.lastUpdated = LastUpdated
                }

                if (Overview) {
                    state.overview = Overview
                    state.overview.TOTAL = {
                        ...Overview?.TOTAL,
                        ...Overview?.TOTAL?.TOTAL
                    }
                    state.overview.DISPLAY = {
                        ...Overview?.DISPLAY,
                        ...Overview?.DISPLAY?.TOTAL
                    }
                    state.overview.VIDEO = {
                        ...Overview?.VIDEO,
                        ...Overview?.VIDEO?.TOTAL
                    }
                }

                if (Details) {
                    state.details = Details
                }

                if (CompareTo) {
                    state.compareTo = CompareTo
                }

                if (LastUpdated && Overview && Details && CompareTo) {
                    state.status = 'fulfilled'
                    state.isRevenueDataReceived = true
                } else {
                    state.isRevenueDataReceived = false
                    state.status = 'rejected'
                }
            })
            .addCase(fetchRevenueDetailData.rejected, (state, action) => {
                state.status = 'rejected'
            })
    }
});

// export const {  } = revenueSlice.actions;
export default revenueSlice.reducer;
